export default __webpack_public_path__ + "static/media/icon-number.7e571043.svg";